import { useAuth } from "../hooks/useAuth";
import { Navigate } from "react-router-dom";

const C = { bg: "#0a0a0f", text: "#e8e6e1", accent: "#6366f1" };
const SYNE = "'Syne', sans-serif";

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();

    if (loading) {
        return (
            <div style={{ background: C.bg, minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <div style={{ color: C.accent, fontFamily: SYNE, fontWeight: 800, fontSize: "1.4rem" }}>
                    DGB
                </div>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    return children;
}